module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.propIsShowIcon && !_vm.propIsWhiteIcon && !_vm.propIsBlackIcon) ? _c('svg', {
    style: ({
      'margin-right': _vm.marginRight
    }),
    attrs: {
      "width": _vm.iconWidth,
      "viewBox": "0 0 60 60",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Logos",
      "transform": "translate(-636.000000, -534.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "logo-mgtb",
      "transform": "translate(636.000000, 534.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "symbol-mgtb"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Fill-25",
      "fill": "#7C70BF",
      "points": "0 55.5517241 39.9972414 55.5517241 39.9972414 15.5544828 0 15.5544828"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-27",
      "fill": "#43CDEF",
      "points": "15.5544828 39.9972414 55.5517241 39.9972414 55.5517241 0 15.5544828 0"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-28",
      "fill": "#34BCDD",
      "points": "15.5544828 0 40.0354666 13.3643926 40.0354666 39.9985768 15.5544828 39.9985768"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-28-Copy",
      "fill": "#5A4F8D",
      "points": "15.5544828 40.0020382 39.9898968 40.0020382 39.9898968 55.5402291"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.propIsShowIcon && _vm.propIsWhiteIcon) ? _c('svg', {
    style: ({
      'margin-right': _vm.marginRight
    }),
    attrs: {
      "width": _vm.iconWidth * 0.92,
      "viewBox": "0 0 100 100",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "MGTB_-library-(product)",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Logos",
      "transform": "translate(-765.000000, -1112.000000)",
      "fill": "#FFFFFF"
    }
  }, [_c('g', {
    attrs: {
      "id": "symbol-mgtb-white",
      "transform": "translate(765.000000, 1112.000000)"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Fill-25",
      "fill-opacity": "0.6",
      "points": "0 100 72 100 28.0205078 72.0410156 28.0205078 28 0 28"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-27",
      "fill-opacity": "0.8",
      "points": "72.0390625 24.1152344 72.0390625 72 100 72 100 0 28 0"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-28",
      "fill-opacity": "0.7",
      "points": "28 0 72.0688101 24.0575658 72.0688101 72.0024038 28 72.0024038"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-28-Copy",
      "fill-opacity": "0.4",
      "points": "28 72.0086349 71.9867788 72.0086349 71.9867788 99.9793074"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.propIsShowIcon && _vm.propIsBlackIcon) ? _c('svg', {
    style: ({
      'margin-right': _vm.marginRight
    }),
    attrs: {
      "width": _vm.iconWidth,
      "viewBox": "0 0 59 58",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Logos",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-636.000000, -1490.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "logo-lightgray",
      "transform": "translate(636.000000, 1490.000000)",
      "fill": "#011B32"
    }
  }, [_c('g', {
    attrs: {
      "id": "symbol-lightgray"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Fill-25",
      "fill-opacity": "0.5",
      "points": "0 58 39 58 18.2489058 38.2856897 18.2489058 18 0 18"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-27",
      "fill-opacity": "0.4",
      "points": "38.7046547 38 59 38 59 0 18 0 38.7046547 18.1116364"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-28",
      "fill-opacity": "0.75",
      "points": "18 0 39 18.1004191 39 38 18 38"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Fill-28",
      "fill-opacity": "0.9",
      "points": "39 38 39 58 18 38"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.propIsShowText) ? _c('svg', {
    staticClass: "scaling-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": _vm.propWidth,
      "viewBox": "0 0 86 17"
    }
  }, [_c('g', {
    attrs: {
      "id": "MGTB_-library-(product)",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Checkboxes",
      "transform": "translate(-55.000000, -24.000000)",
      "fill": _vm.propColor
    }
  }, [_c('g', {
    attrs: {
      "id": "menu-copy-3"
    }
  }, [_c('g', {
    attrs: {
      "id": "logo",
      "transform": "translate(25.000000, 24.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "logotype-darkgray",
      "transform": "translate(30.000000, 0.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.95202285,0.924040432 L7.29235827,9.71951129 L10.6638192,0.85298187 C10.6638192,0.85298187 10.7890287,0.339063384 11.295526,0.339063384 L13.0074302,0.339063384 C13.0074302,0.339063384 13.2090388,0.314659433 13.2394569,0.561569991 L14.3380467,12.6235814 C14.3380467,12.6235814 14.4208123,12.9724143 14.1081422,12.9724143 L12.5263993,12.9724143 C12.5263993,12.9724143 12.2865912,13.0248111 12.2554657,12.6565985 L11.5204787,4.04631057 L8.34143015,12.2252228 C8.34143015,12.2252228 8.2763495,12.5575472 7.96863117,12.5575472 L6.65428488,12.5575472 C6.65428488,12.5575472 6.38405868,12.5998952 6.2843155,12.2826439 L3.0706044,4.04272175 L2.31581026,12.7333992 C2.31581026,12.7333992 2.33349522,12.9688255 2.07670959,12.9688255 L0.499211077,12.9688255 C0.499211077,12.9688255 0.207762921,13.0075847 0.239595851,12.7025354 L1.33818562,0.624733157 C1.33818562,0.624733157 1.31767107,0.332603515 1.57021231,0.332603515 L3.28636092,0.332603515 C3.28636092,0.332603515 3.7497069,0.28307785 3.95202285,0.924040432 Z",
      "id": "Fill-3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.8038892,1.18164566 C36.8038892,1.80968851 36.4926339,2.32001818 35.6189968,2.32001818 C34.7750705,2.32001818 34.4348119,1.80968851 34.4348119,1.18164566 C34.4348119,0.552885056 34.7665817,0.0432731488 35.6189968,0.0432731488 C36.5060745,0.0432731488 36.8038892,0.552885056 36.8038892,1.18164566",
      "id": "Fill-5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.6029173,12.762971 C36.6029173,12.8620223 36.5251035,12.9416941 36.4274825,12.9416941 L34.8124919,12.9416941 C34.7155783,12.9416941 34.6370571,12.8620223 34.6370571,12.762971 L34.6370571,3.98257319 C34.6370571,3.88208634 34.7155783,3.80313238 34.8124919,3.80313238 L36.4274825,3.80313238 C36.5251035,3.80313238 36.6029173,3.88208634 36.6029173,3.98257319 L36.6029173,12.762971 Z",
      "id": "Fill-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.3961309,12.8134298 C76.3961309,12.9131989 76.3169023,12.9935884 76.2192813,12.9935884 L74.5993388,12.9935884 C74.5003031,12.9935884 74.4210744,12.9131989 74.4210744,12.8134298 L74.4210744,0.504507813 C74.4210744,0.404738721 74.5003031,0.323631474 74.5993388,0.323631474 L76.2192813,0.323631474 C76.3169023,0.323631474 76.3961309,0.404738721 76.3961309,0.504507813 L76.3961309,12.8134298 Z",
      "id": "Fill-9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45.2319049,4.22302388 L45.2319049,5.20635953 C45.2319049,5.20635953 45.2616157,5.47552075 44.9878525,5.47552075 L42.2785165,5.47552075 C42.2785165,5.47552075 41.2103448,5.44465693 40.8410828,5.96718858 C40.8410828,5.96718858 40.4866762,6.32822349 40.4527211,7.54842101 C40.4527211,7.54842101 40.4109846,8.9997383 40.4944576,9.78856011 C40.5340719,10.1704102 40.6536223,10.5974793 40.9068709,10.8896089 C41.2435926,11.2750478 41.8399294,11.3059116 42.306105,11.310936 L44.9043795,11.310936 C44.9043795,11.310936 45.2319049,11.2635636 45.2382715,11.6023478 L45.2382715,12.5368756 C45.2382715,12.5368756 45.2757637,12.8182388 44.9616787,12.8591513 C44.9616787,12.8591513 43.8935071,13.0285434 42.9979407,13.0292612 C42.1922139,13.0292612 41.4190274,13.0536651 40.6338151,12.9029349 C39.9780568,12.7766085 39.3923309,12.4521795 39.0195319,11.8851466 C38.7033248,11.4028097 38.6064112,10.7360076 38.5349639,10.1567727 C38.4918126,9.80363314 38.4691759,9.44762257 38.4557353,9.09089424 C38.4557353,9.09089424 38.3623587,6.53278602 38.7585019,5.4647543 C38.7585019,5.4647543 39.0004321,4.47567654 40.0148415,4.07301136 C40.0148415,4.07301136 40.7095067,3.77011527 42.0634673,3.74140474 C42.0634673,3.74140474 43.8836035,3.72776724 44.9114535,3.904337 C44.9114535,3.904337 45.2319049,3.92228108 45.2319049,4.22302388",
      "id": "Fill-11"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52.5552473,1.45260129 L52.5552473,3.78963843 L54.1221348,3.78963843 C54.1221348,3.78963843 54.4390493,3.77097658 54.4390493,4.07602597 L54.4390493,5.07299912 C54.4390493,5.07299912 54.46876,5.34072481 54.127794,5.34072481 L52.5552473,5.34072481 L52.5552473,10.4232064 C52.5552473,10.6643748 52.5913246,10.997417 52.8183995,11.1352275 C53.0086897,11.2515052 53.3008452,11.2443275 53.5123574,11.2479164 L54.3322321,11.2479164 C54.3322321,11.2479164 54.5706254,11.2235124 54.5706254,11.5084644 L54.5706254,12.5549632 C54.5706254,12.5549632 54.6045805,12.8112047 54.3385987,12.8571416 C54.3385987,12.8571416 53.6948662,12.9906455 52.9188501,12.9798791 L52.9138983,12.9798791 C52.1874001,12.9856212 51.3611587,12.9231758 50.8971053,12.2807777 C50.5992906,11.8709349 50.5681651,11.3685006 50.5603837,10.8775505 L50.5603837,5.34072481 L49.6358139,5.34072481 C49.6358139,5.34072481 49.3670025,5.36153995 49.3670025,5.04931293 L49.3670025,4.09971215 C49.3670025,4.09971215 49.3387066,3.78102527 49.7037242,3.78963843 L50.5667503,3.78963843 L50.5667503,1.93350267 C50.5667503,1.93350267 50.5356247,1.68730987 50.763407,1.62845329 L52.2680435,1.23799008 C52.2680435,1.23799008 52.5552473,1.16836704 52.5552473,1.45260129",
      "id": "Fill-13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4896369,10.2273288 C70.4740741,10.3077183 70.45073,10.3881078 70.4196044,10.4641907 C70.2399252,10.9120749 69.8190232,11.1675986 69.3634586,11.2451171 C68.7395332,11.3520638 68.0455753,11.293925 67.4188203,11.2357862 C67.3841577,11.2329151 66.7694285,11.1783651 66.7694285,11.1518079 L66.7694285,5.44056568 L68.7904658,5.44056568 C69.4709831,5.44056568 69.8246824,5.63077294 69.8246824,5.63077294 C70.3955529,5.87409468 70.5844283,6.6255928 70.6056502,7.1998034 C70.6304092,7.89029165 70.6480941,8.59728845 70.610602,9.29064775 C70.5929171,9.61077016 70.5533027,9.9165373 70.4896369,10.2273288 M72.616784,7.8579923 C72.6139544,7.72089952 72.60971,7.58380674 72.6033434,7.44814949 C72.5722179,6.69521584 72.4611563,5.93797561 72.2029559,5.22882552 C72.1810266,5.16566235 72.1548528,5.10393472 72.1258495,5.04292484 C71.6660405,4.08829972 70.6480941,3.82631613 69.7001802,3.73803125 C69.5176714,3.7215227 69.3372848,3.71003848 69.1540686,3.70429638 C68.8060286,3.6920944 68.4579886,3.69711875 68.1106559,3.71147401 C67.6621653,3.73013586 67.2136747,3.76458849 66.7694285,3.81842074 L66.7694285,0.477950573 C66.7694285,0.378181481 66.6901999,0.297791997 66.5911641,0.297791997 L64.9754661,0.297791997 C64.8778451,0.297791997 64.7986165,0.378181481 64.7986165,0.477950573 L64.7986165,12.4114824 C64.7986165,12.552164 64.8665267,12.6440377 64.9542441,12.6906923 C65.0787462,12.7567265 65.4996483,12.8062521 65.6227356,12.824914 C65.9792645,12.8780285 66.3393303,12.9110456 66.6993961,12.9397561 C66.9519373,12.9605712 67.2044785,12.9785153 67.459142,12.9907173 C68.263454,13.0273232 69.0776696,13.0423963 69.8798594,12.9526758 C70.2087997,12.9160699 70.53774,12.8507535 70.8511175,12.7366291 C71.0124043,12.6784903 71.1687394,12.6059962 71.3172931,12.5169936 C71.906556,12.1652896 72.2524738,11.5566263 72.4010275,10.8869532 C72.4512528,10.6587045 72.4837931,10.4254314 72.5170408,10.1935939 C72.5375554,10.0442992 72.5531181,9.89428664 72.5665587,9.74499189 C72.6189062,9.12125562 72.630932,8.48603515 72.616784,7.8579923",
      "id": "Fill-15"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M83.9281557,7.75126091 L80.1853106,7.75126091 C80.1853106,7.21006742 80.2829316,6.62867919 80.2829316,6.62867919 C80.3642824,6.20304558 80.6536084,5.77454092 81.0667291,5.63601261 C81.4275023,5.51399286 81.8165714,5.49676654 82.195737,5.50322641 C82.6527164,5.51183957 83.1648728,5.5484455 83.4987649,5.90732712 C83.7696985,6.19802124 83.8560011,6.59494431 83.894908,6.98253647 C83.9005672,7.03062661 83.9430111,7.75126091 83.9281557,7.75126091 M85.9194823,8.74536301 C85.9194823,7.61129707 85.8650127,6.95526146 85.8650127,6.95526146 C85.8360093,6.62078379 85.8077134,6.28917717 85.7369735,5.9604416 C85.6181306,5.40130403 85.3995445,4.87231251 84.9758128,4.48256707 C84.8880954,4.40145982 84.7918892,4.32896573 84.6900239,4.26652033 C84.2457776,3.9858749 83.7074474,3.84949988 83.188217,3.81720054 C80.6649267,3.65857486 79.8938625,4.05262688 79.8938625,4.05262688 C78.838424,4.41868614 78.563246,5.38120666 78.563246,5.38120666 C78.1267812,6.374591 78.1996432,8.99514462 78.1996432,8.99514462 C78.2137912,9.79760393 78.2689682,10.640258 78.5356575,11.4032403 C78.57032,11.5015739 78.6085195,11.5977542 78.6545004,11.6910634 C78.9968812,12.3750918 79.6561766,12.7892412 80.388334,12.9248984 C80.6139941,12.9665287 80.841069,13.0060057 81.0695587,13.0253853 C82.1575374,13.1208478 83.6459038,13.0390228 84.1658416,12.9894971 C84.4155533,12.9658109 84.6673871,12.9385359 84.9163914,12.9004945 C85.270798,12.8588642 85.249576,12.5566859 85.249576,12.5566859 L85.249576,11.5999075 C85.249576,11.2991646 84.9581279,11.3307462 84.9581279,11.3307462 L82.2240329,11.3307462 C81.7769571,11.3357706 81.4954125,11.2941403 81.4954125,11.2941403 C80.6677563,11.2144686 80.4385592,10.6488711 80.4385592,10.6488711 C80.1937994,10.1579211 80.1937994,9.1810453 80.1937994,9.1810453 L85.4476476,9.1810453 C85.9520227,9.18678741 85.9194823,8.74536301 85.9194823,8.74536301",
      "id": "Fill-17"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.5851496,11.2029844 C30.5851496,11.2029844 29.9746647,11.2876804 28.774917,11.2876804 C28.774917,11.2876804 27.7697038,11.343666 27.3042356,10.9567916 C27.3042356,10.9567916 26.7779312,10.6043698 26.7567092,9.38704335 C26.7567092,9.38704335 26.7128505,7.62134576 26.8196677,6.74782789 C26.8196677,6.74782789 26.8543302,5.77669421 27.8531768,5.55275207 C27.8531768,5.55275207 28.1715061,5.48887115 28.7473284,5.48169351 L30.5851496,5.48169351 L30.5851496,11.2029844 Z M32.5658652,4.46031641 C32.5658652,4.07057096 32.1527445,4.01817425 32.1527445,4.01817425 C30.9537042,3.74973079 28.6780034,3.74327092 28.6780034,3.74327092 C26.8125937,3.74973079 26.1257098,4.20048611 26.1257098,4.20048611 C25.1346446,4.68641183 24.9195955,6.06523504 24.9195955,6.06523504 C24.6599803,7.49071285 24.7667974,9.26789465 24.7667974,9.26789465 C24.8361225,11.03431 25.2796613,11.737718 25.2796613,11.737718 C25.849117,12.8358958 27.1111158,12.9349471 27.1111158,12.9349471 C29.0168472,13.1940596 30.5851496,12.8854214 30.5851496,12.8854214 C30.6007123,13.541457 30.4896508,13.8895722 30.390615,14.069013 C30.3899076,14.0726018 30.3821262,14.0848038 30.3672708,14.1077722 C30.3474637,14.1400716 30.3283639,14.1644755 30.310679,14.1838551 C30.2675277,14.2384052 30.2031544,14.3044394 30.118974,14.3668848 C30.0722857,14.4027729 30.0220604,14.4343545 29.9654685,14.4616295 C29.4632156,14.7042335 28.6157523,14.6719342 28.6157523,14.6719342 L26.0500182,14.6719342 C25.7373481,14.6791118 25.7720106,14.9547329 25.7720106,14.9547329 L25.7720106,15.7844672 C25.7720106,16.1261225 26.1051953,16.1677528 26.1051953,16.1677528 C26.9024333,16.2833127 27.7060379,16.3378627 28.51035,16.3378627 C29.8381368,16.3371449 31.5167933,16.261062 32.201555,14.8764967 C32.4456075,14.3805223 32.4937106,13.771859 32.5276657,13.2270767 C32.5552542,12.7777569 32.5439358,12.3313082 32.5453506,11.8834239 C32.546058,11.6515864 32.5658652,4.88379673 32.5658652,4.46031641 Z",
      "id": "Fill-19"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21.0601711,11.1718334 C21.0601711,11.2206414 20.2579813,11.297442 20.2084634,11.3024664 C19.6835737,11.351992 19.1629285,11.3720894 18.6387462,11.321846 C18.2525067,11.2859578 17.821701,11.1352275 17.6540476,10.7390222 C17.494883,10.3643498 17.4906386,9.82746288 17.7339836,9.48580758 C17.93347,9.20444438 18.3083912,9.08744897 18.6380388,9.08601345 L21.0601711,9.0809891 L21.0601711,11.1718334 Z M21.1853806,3.97482135 C20.2926438,3.74441934 18.8969467,3.76451672 18.8969467,3.76451672 C17.4573909,3.78533185 16.5321137,3.98199898 16.5321137,3.98199898 C16.2972574,4.01645162 16.3319199,4.2511602 16.3319199,4.2511602 L16.3319199,5.27756165 C16.3319199,5.49432615 16.5597022,5.48068864 16.5597022,5.48068864 L19.3687814,5.48068864 C21.1500107,5.46920443 21.0538045,6.69299077 21.0538045,6.69299077 L21.0538045,7.65838234 L18.4102565,7.65838234 C17.5337899,7.680633 16.4790588,7.83136329 15.9845873,8.67545287 C15.7652938,9.04940752 15.6726246,9.44776612 15.6365473,9.8798596 C15.582785,10.5423551 15.6386695,11.2594006 15.9435582,11.8601684 C16.1352632,12.2391474 16.387097,12.5097441 16.7733366,12.6848784 C17.2140458,12.8851343 17.7049803,12.9389666 18.1817669,12.9791613 C19.455084,13.0853903 20.8026781,13.0100251 22.0639695,12.7868008 C22.2535523,12.7537837 22.4367685,12.7100001 22.624229,12.6669343 C23.0345201,12.5729073 23.0274461,12.1702421 23.0274461,12.1702421 L23.0274461,6.36281968 C23.0550347,4.28991941 21.1853806,3.97482135 21.1853806,3.97482135 Z",
      "id": "Fill-21"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.8775777,11.1718334 C60.8775777,11.2206414 60.0753878,11.297442 60.0251625,11.3024664 C59.5009803,11.351992 58.9789203,11.3720894 58.4561528,11.321846 C58.0706207,11.2859578 57.6384002,11.1352275 57.4714542,10.7390222 C57.3115821,10.3643498 57.3073378,9.82746288 57.5506828,9.48580758 C57.7501692,9.20444438 58.1257977,9.08744897 58.454738,9.08601345 L60.8775777,9.0809891 L60.8775777,11.1718334 Z M61.0027872,3.97482135 C60.109343,3.74441934 58.7136458,3.76451672 58.7136458,3.76451672 C57.27409,3.78533185 56.3495203,3.98199898 56.3495203,3.98199898 C56.114664,4.01645162 56.1479117,4.2511602 56.1479117,4.2511602 L56.1479117,5.27756165 C56.1479117,5.49432615 56.3778162,5.48068864 56.3778162,5.48068864 L59.186188,5.48068864 C60.9674173,5.46920443 60.8705037,6.69299077 60.8705037,6.69299077 L60.8705037,7.65838234 L58.2269557,7.65838234 C57.3504891,7.680633 56.295758,7.83136329 55.8012865,8.67545287 C55.5827004,9.04940752 55.4900312,9.44776612 55.4546612,9.8798596 C55.4001916,10.5423551 55.4546612,11.2594006 55.7609648,11.8601684 C55.9533771,12.2391474 56.205211,12.5097441 56.5900357,12.6848784 C57.0314524,12.8851343 57.5216795,12.9389666 57.998466,12.9791613 C59.2717832,13.0853903 60.6200846,13.0100251 61.8820834,12.7868008 C62.0702514,12.7537837 62.254175,12.7100001 62.4409282,12.6669343 C62.8519267,12.5729073 62.8448527,12.1702421 62.8448527,12.1702421 L62.8448527,6.36281968 C62.8731487,4.28991941 61.0027872,3.97482135 61.0027872,3.97482135 Z",
      "id": "Fill-23"
    }
  })])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3022be6b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/logo/Logo.vue
// module id = H07B
// module chunks = 0